export default "__VITE_ASSET__DUVxin4i__"